module.exports = __webpack_public_path__ + "static/img/case41.029c328.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/case41.png
// module id = YD4S
// module chunks = 3